import { getMetaData } from "../data/redux-state"
import * as React from "react"
import {
  DEFAULT_FLYOUT_SIGNIFICANT_DIGITS,
  formatToSignificantDigits,
} from "../utils/format"
import { useIntl } from "gatsby-plugin-intl"
import { extractOptionalTranslation } from "./VariableDropdown"
import { getActiveUnitOverride } from "../utils/unitParam"
import { getDerivMode } from "../utils/derivParam"

export const TooltipClickOnDataPoints = (props: any) => {
  const intl = useIntl()
  const xPosition = props.click[0]
  const yPosition = props.click[1]
  const styles = {
    left: `${xPosition}px`,
    top: `${yPosition}px`,
    position: "absolute",
    zIndex: 10,
    backgroundColor: "white",
    padding: "5px",
    borderRadius: "5px",
    boxShadow: "4px 4px 10px rgba(0, 100, 100, 0.4)",
    fontSize: window.innerWidth >= window.innerHeight ? "14px" : "10px",
    fontWeight: "normal",
    fontFamily: "sans-serif",
  }
  const textContainerStyles = {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    lineHeight: 1.1,
  } as const
  const precision: number =
    props.significantDigits ?? DEFAULT_FLYOUT_SIGNIFICANT_DIGITS
  const metaData: FileMetadata | null = getMetaData(props.appState)
  const unitOverride = getActiveUnitOverride()
  let varUnit =
    unitOverride?.unitString ??
    extractOptionalTranslation({
      parentKey: "varUnits",
      subKey: String(metaData?.VarUnit),
      intl,
    })
  if (getDerivMode() !== null) {
    varUnit += "/yr"
  }
  const formattedNumber = formatToSignificantDigits(
    props.dataPoint.value,
    precision
  )
  return (
    <div
      onClick={() => props.removeClickedDots()}
      className="Tooltip"
      style={styles as any}
    >
      <div style={textContainerStyles}>
        <div>{formattedNumber + " " + varUnit}</div>
        <div>{props.dataPoint.date.getFullYear()}</div>
      </div>
    </div>
  )
}
